import themeGet from '@styled-system/theme-get';
import { ChevronDown } from 'pcln-icons';
import React from 'react';
import styled, { css } from 'styled-components';
import { borderRadius, compose, fontSize, space } from 'styled-system';
import { Flex } from '../Flex/Flex';
import { borderRadiusAttrs } from '../utils/attrs/borderRadiusAttrs';
import { applySizes, applyVariations, borders, getPaletteColor } from '../utils/utils';
/**
 * @public
 */
export const selectSizes = {
  sm: css(["padding:6px 32px 7px 12px;"]),
  md: css(["padding:10px 32px 11px 12px;"]),
  lg: css(["padding:14px 32px 14px 12px;"]),
  xl: css(["padding:18px 32px 19px 12px;"])
};
/**
 * @public
 */
const variations = {
  input: css([""]),
  subtle: css(["background-color:", ";border-color:", ";border-radius:", ";color:", ";font-weight:bold;&:hover{background-color:", ";border-color:", ";color:", ";~ svg{color:", ";}}&:focus-visible{outline:0px solid ", ";box-shadow:0 0 0 2px ", ";}& ~ svg{color:", ";}"], getPaletteColor('background.base'), getPaletteColor('background.base'), props => props.size === 'sm' || props.size === 'md' ? themeGet('borderRadii.full') : themeGet('borderRadii.lg'), getPaletteColor('primary.base'), getPaletteColor('background.tint'), getPaletteColor('background.tint'), getPaletteColor('primary.dark'), getPaletteColor('primary.dark'), getPaletteColor('primary.dark'), getPaletteColor('primary.dark'), getPaletteColor('primary.base'))
};
const ClickableIcon = /*#__PURE__*/styled(ChevronDown).withConfig({
  displayName: "Select__ClickableIcon",
  componentId: "sc-m07nxd-0"
})(["pointer-events:none;"]);
const SelectBase = /*#__PURE__*/styled.select.attrs(borderRadiusAttrs).withConfig({
  displayName: "Select__SelectBase",
  componentId: "sc-m07nxd-1"
})(["appearance:none;background-color:transparent;border-style:solid;border-width:1px;border-radius:", ";color:inherit;display:block;font-family:inherit;text-overflow:ellipsis;width:100%;::-ms-expand{display:none;}&:hover{cursor:pointer;}&:disabled{background-color:", ";color:", ";cursor:not-allowed;opacity:1;~ svg{color:", ";}}", ";", " ", ";", ""], themeGet('borderRadii.lg'), getPaletteColor('background.light'), getPaletteColor('text.light'), getPaletteColor('text.light'), ({
  theme
}) => applySizes(selectSizes, undefined, theme.mediaQueries), borders, applyVariations('Select', variations), props => compose(space, fontSize, borderRadius)(props));
SelectBase.defaultProps = {
  fontSize: [2, null, 1],
  m: 0,
  size: 'lg'
};
/**
 * @public
 */
export const Select = React.forwardRef(({
  variation = 'input',
  ...props
}, ref) => React.createElement(Flex, {
  width: 1,
  alignItems: 'center'
}, React.createElement(SelectBase, {
  ...props,
  ref: ref,
  variation: variation
}), React.createElement(ClickableIcon, {
  ml: -32,
  color: 'text.light'
})));
Select.displayName = 'Select';
// @ts-ignore
Select.isField = true;